import { FormProvider, useFormContext } from "../context/form-context"
import { Message } from "./message"
import { Modal } from "./modal"
import { Step } from "./step"

export const Form = (props) => {
  return (
    <FormProvider ep={props.ep} contactEp={props.contactEp}>
      <FormContent />
    </FormProvider>
  )
}

const FormContent = () => {
  const {
    step,
    stepClass,
    loading,
    data,
    modalData,
    messageData,
    help,
    formRef,
    ep,
    setModalData,
  } = useFormContext()

  return (
    <form ref={formRef} data-help={help}>
      {messageData.message && <Message data={messageData} />}
      {!loading && data.steps && (
        <Step
          class={stepClass}
          key={step}
          stepId={step}
          step={data.steps[step]}
        />
      )}
      {modalData.contents && (
        <Modal {...modalData} ep={ep} setModalData={setModalData} />
      )}
    </form>
  )
}
